/**
 * This module define
 *
 */
import Vue from 'vue';
import Uploader from '@/libs/uploader';

const uploadQueue = {
  namespaced: true,
  state: {
    activeCounter: 0,
    uploader: null,
  },
  getters: {},
  mutations: {
    // Main video uploading commits
    addVideo(state, { fileMeta, updateHandler }) {
      const id = fileMeta.id;
      const queue = state[id] || {};
      Vue.set(state, id, {
        video: queue.video || {},
      });
      Vue.set(state[id].video, 'instance', state.uploader.upload(fileMeta, updateHandler));
      Vue.set(state[id].video, 'fileMeta', fileMeta);
      state.activeCounter += 1;
    },
    updateVideo(state, { id, progress }) {
      Vue.set(state[id].video, 'progress', progress);
    },
    removeVideo(state, { id }) {
      Vue.delete(state[id], 'video');
      state.activeCounter -= 1;
    },

    setupUploader(state) {
      state.uploader = state.uploader || new Uploader();
    },
  },
  actions: {
    /**
     * Add a video file into the queue. This will also kick off the AWS uploading process.
     * Completed or failed video upload will cause the removal of this video from uploadQueue.
     * An error will be thrown on failure to upload.
     * @param {*} Context of the Vuex store
     * @param {*} fileMeta
     * @returns the url to AWS upon the completion of uploading
     */
    enqueueVideo({ state, commit, getters }, fileMeta) {
      commit('setupUploader');

      // Initialise a blank video item
      commit('addVideo', {
        fileMeta,
        updateHandler(progress) {
          commit('updateVideo', { id: fileMeta.id, progress });
        },
      });
      return state[fileMeta.id].video.instance
        .then((awsPath) => {
          commit('removeVideo', { id: fileMeta.id });
          return awsPath;
        })
        .catch((error) => {
          commit('removeVideo', { id: fileMeta.id });
          throw error;
        });
    },
    /**
     * Dequeue video form the upload queue.
     * This will cancel specified on-going upload a submission.
     * @param {*} Context of the Vuex store
     * @param {*} submissionId
     */
    dequeueVideo({ state, commit, getters }, submissionId) {
      const fileMeta = state[submissionId].video.fileMeta;

      state.uploader.cancel(fileMeta);
    },
  },
};

export default uploadQueue;



// WEBPACK FOOTER //
// ./src/store/modules/uploadQueue.js